import { Injectable, signal } from "@angular/core";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class LoginStateService {
  private readonly _loggedIn = signal<boolean>(false);
  /** Signal accessor — call as a function: `loginStateService.loggedIn()` */
  public readonly loggedIn = this._loggedIn.asReadonly();

  constructor(private router: Router) {}

  @Output() loggedInChange: EventEmitter<any> = new EventEmitter();

  public toggleLoggedIn(loggedIn: boolean) {
    this._loggedIn.set(loggedIn);
    this.loggedInChange.emit(loggedIn);
  }

  public logout() {
    this.toggleLoggedIn(false);
    this.router.navigate(["/start"]);
  }
}
